import {
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBModal,
    MDBRow,
} from "mdb-react-ui-kit";
import { FC, useEffect, useState } from "react";
import userInterfaceSvg from "../../utils/svg-icon/userInterface";
import styles from "../../styles/detail/Detail.ModalMap.module.scss";

const ModalMap: FC<{
    url: string | undefined;
    show: boolean;
    setShow: (el: boolean) => void;
}> = ({ url, show, setShow }) => {
    const { CloseLine } = userInterfaceSvg;

    const toggleShow = () => setShow(!show);
    const [render, setRender] = useState(false);

    useEffect(() => setRender(true), []);

    return (
        <div>
            {render && (
                <MDBModal show={show} setShow={setShow} tabIndex="-1">
                    <MDBContainer
                        fluid
                        className="d-flex justify-content-center align-items-center p-0 vh-100 vw-100"
                        style={{ backgroundColor: "#282838" }}
                    >
                        <MDBCol className="d-flex flex-column h-100 w-100">
                            <MDBRow className="mt-3 justify-content-end">
                                <MDBCol center size={2} lg={1}>
                                    <MDBBtn
                                        className={` ${styles.button} d-flex justify-content-center shadow-0`}
                                        tag="a"
                                        floating
                                        onClick={toggleShow}
                                    >
                                        <CloseLine className="align-self-center" />
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="flex-fill justify-content-center">
                                <MDBCol
                                    center
                                    size={12}
                                    className="px-5 px-lg-0 d-flex justify-content-center align-items-center h-100"
                                >
                                    <iframe
                                        id="map"
                                        src={url}
                                        allow="geolocation"
                                        className={styles.mapContainer}
                                        title="map"
                                        style={{
                                            overflowY: "hidden",
                                            width: "100%",
                                        }}
                                    />
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>
                    </MDBContainer>
                </MDBModal>
            )}
        </div>
    );
};

export default ModalMap;
